import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { UnsignedPaymentsTemporary } from './UnsignedPaymentsTemporary.tsx';
import { PAYMENT_SYSTEMS } from 'src/Utilities';
import { ContentLoader, ContentNoData } from 'src/Components';
import { OMCActions } from 'src/Redux';
import { UnsignedPayments } from './UnsignedPayments';

export const UnsignedPaymentsWrapper = () => {
  const dispatch = useDispatch();
  const { sendUOLR, UOLR } = useSelector((state: any) => state.OMCReducers);

  useEffect(() => {
    dispatch(OMCActions.postUOLR() as any);
  }, []);

  if (sendUOLR) {
    return <ContentLoader />;
  }

  if (!UOLR?.Operations?.length) {
    return <ContentNoData id="UnsignedPaymentsWrapper" />;
  }

  return (
    <>
      <UnsignedPayments
        UOLR={{ Operations: UOLR?.Operations?.filter((e: any) => e.VopResponseType || [PAYMENT_SYSTEMS.TARGET2, PAYMENT_SYSTEMS.INTERNATIONAL].includes(e.PaymentSystem)) }}
        sendUOLR={sendUOLR}
      />
      {UOLR?.Operations?.filter((e: any) => !e.VopResponseType)?.length > 0 && (
        <UnsignedPaymentsTemporary
          UOLR={{ Operations: UOLR?.Operations?.filter((e: any) => !e.VopResponseType && [PAYMENT_SYSTEMS.SEPA, PAYMENT_SYSTEMS.INST].includes(e.PaymentSystem)) }}
          sendUOLR={sendUOLR}
        />
      )}
    </>
  );
};
